<template>
  <v-container grid-list-xl>
    <v-layout row justify-center align-center wrap class="mt-4 pt-2">
      <v-flex xs12 sm12 md6 lg6 xl6>
        <h2 class="pb-4 mt-2">
          <span>GetIn</span>
          <span class="blue--text">Touch</span>
        </h2>
        <div class="py-4 subheading font-weight-bold">
          <v-icon large color="blue" left>fas fa-map-marker-alt</v-icon>
          <span>Dhrangadhra,&nbsp;</span>
          <span class="blue--text">Gujarat, India</span>
        </div>
       
        <div class="py-4 subheading font-weight-bold">
        <a href="mailto:hey@midhunnair.live" style="text-decoration:none"><v-icon large color="blue" left>fas fa-envelope</v-icon></a>
         
         <span>hey@</span><a href="mailto:hey@midhunnair.live" style="text-decoration:none;"><span class="blue--text">midhunnair.live</span></a>
        </div>
      
        <div class="py-4 subheading font-weight-bold">
        <a href="tel:+919924757959" style="text-decoration:none;">
          <v-icon large color="blue" left>fas fa-phone</v-icon></a>
          <span>+91&nbsp;</span>
          <a href="tel:+919924757959" style="text-decoration:none;"><span class="blue--text">9924757959</span></a>
        </div>

        <div class="py-4 subheading font-weight-bold">
          <v-icon large color="blue" left>fas fa-check</v-icon>
          <span>Freelance</span>
          <span class="blue--text">Available</span>
        </div>
        <h2 class="pb-4 mt-2">
          <span>Follow</span>
          <span class="blue--text">Me</span>
        </h2>
        <div class="pb-4">
          <a
            v-for="icon in icons"
            :key="icon.icon"
            :href="icon.href"
            target="_blank"
            style="text-decoration:none"
          >
          <v-icon medium :color="icon.color" left>{{icon.icon}}</v-icon>
          </a>
        </div>
      </v-flex>

      <v-flex xs12 sm12 md6 lg6 xl6>
        <h2 class="pb-4 mb-4">
          <span>Contact</span>
          <span class="blue--text">Form</span>
        </h2>

        <form ref="formElement">
          <v-text-field
            name="entry.99962702"
            id="name"
            color="blue"
            background-color="transparent"
            v-model="name"
            :error-messages="nameErrors"
            label="Name"
            required
            @blur="$v.name.$touch()"
          ></v-text-field>
          <v-text-field
            type="email"
            id="email"
            color="blue"
            background-color="transparent"
            name="entry.1944393441"
            v-model="email"
            :error-messages="emailErrors"
            label="E-mail"
            required
            @blur="$v.email.$touch()"
          ></v-text-field>
          <v-textarea
            color="blue"
            id="msg"
            background-color="transparent"
            :counter="200"
            :error-messages="bodyErrors"
            v-model="body"
            label="Textarea"
            name="entry.1911032774"
            @blur="$v.body.$touch()"
          ></v-textarea>
          <v-btn
            @click="submit"
            type="submit"
            color="blue"
            class="white--text"
            :disabled=" (body.length<=10)"
          >SEND MESSAGE</v-btn>
          <v-btn @click="clear">clear</v-btn>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import axios from 'axios';
import {
  required,
  maxLength,
  email,
  minLength
} from "vuelidate/lib/validators";
export default {
  metaInfo: {
    title: "Contact",
    titleTemplate: "%s ← Midhun Nair",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Midhun Nair's Contact Shivam Society Halvad Road Dhrangadhra Freelance Get in Touch ContactMe"
      },
      { charset: "utf-8" },
      { property: "og:title", content: "Midhun Nair" },
      { property: "og:site_name", content: "Midhun Nair" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "http://midhunnair.live" },
      {
        property: "og:image",
        content: "https://cdn.image4.io/mndesigns/f_auto/66aa3e55-542a-4355-acb3-2602e5d55414.png"
      },
      {
        property: "og:description",
        content:
          "Midhun Nair's Contact Shivam Society Halvad Road Dhrangadhra Freelance Get in Touch ContactMe"
      }
    ]
  },
  mixins: [validationMixin],
  validations: {
    name: { required, maxLength: maxLength(20) },
    email: { required, email },
    body: { required, minLength: minLength(10) }
  },
  data() {
    return {
      icons: [
        {icon: "fa fa-chevron-left" },
        
        { href: "https://github.com/itsmidhunnair", icon: "fab fa-github", color:"blue" },
    
        { href: "https://twitter.com/midhun_n_a_i_r", icon: "fab fa-twitter", color:"blue" },
        {
          href: "https://www.linkedin.com/in/itsmidhunnair/",
          icon: "fab fa-linkedin-in", color:"blue"
        },
        
        {
          href: "https://www.facebook.com/people/Midhun-M-Nair/100009103022377/",
          icon: "fab fa-facebook-f", color:"blue"
        },
        { href: "https://www.instagram.com/itsmidhunnair", icon: "fab fa-instagram", color:"blue" },
          
        { icon: "/" },
        
        { icon: "fa fa-chevron-right" }
      ],
      name: "",
      email: "",
      body: ""
    };
  },
  methods: {
    clear() {
      this.$v.$reset();
      this.name = "";
      this.email = "";
      this.body = "";
    },

    submit() {
      var name = document.getElementById("name").value;
      var email = document.getElementById("email").value;
      var msg = document.getElementById("msg").value;

        if(name && email && msg)
        {
        this.$v.$touch();
        var vm = this;
        var formElement = vm.$refs.formElement;
        var formData = new FormData(formElement);
        var url = 'https://docs.google.com/forms/u/0/d/e/1FAIpQLSeNNyg7ufeCDqWGFcX2QQmVkZ0vc8vU00QvXHrsNRjgCxt0_Q/formResponse';
        alert("Thank You "+name+" for filling the form, The form has been successfully submitted ");
        axios.post(url, formData).then(function(submit){
          console.log(submit);
          })
        }
        else
        {
          alert("Please fill all the Data and then submit.")
        }
    }
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      !this.$v.name.maxLength &&
        errors.push("Name must be at most 20 characters long");
      !this.$v.name.required && errors.push("Name is required.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("E-mail is required");
      return errors;
    },
    bodyErrors() {
      const errors = [];
      if (!this.$v.body.$dirty) return errors;
      !this.$v.body.minLength &&
        errors.push("Text must be at least 10 characters long");
      !this.$v.body.required && errors.push("Text is required");
      return errors;
    }
  }
};
</script>
